import { Component, AfterViewInit, ChangeDetectorRef, OnInit } from '@angular/core';
import { Router} from "@angular/router";
import { PermissionCheckerService, PershingTranslationService } from "@pershing/pershing-core";

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit, AfterViewInit {

  home = '/nxi/overview';
  constructor(
    private router: Router,
    private _changeDetectionRef: ChangeDetectorRef,
    private authorizationService: PermissionCheckerService,
    private translationService: PershingTranslationService) {
      this.translationService.addTranslationFolder("@pershing/nxi-ng-shell", "node_modules/@pershing/nxi-ng-shell/assets");
  }

  ngOnInit() {
    let isOverviewEntitled = this.authorizationService.isEntitled("ACCOUNT_SUMMARY || ACCOUNT_SUMMARY_1")
    if (isOverviewEntitled) {
      this.home = '/nxi/overview';
    } else {
      this.home = '/nxi/settings/allsettings';
    }
  }

  ngAfterViewInit(): void {
    this._changeDetectionRef.detectChanges();
  }

  goToPreviousUrl(){
    let urlBefore404 = localStorage.getItem("urlBefore404");
    if(urlBefore404 === null || urlBefore404 === ''){
      this.goToHome();
    }
    else this.router.navigateByUrl(urlBefore404);
  }

  goToHome(){
    this.router.navigateByUrl(this.home);
  }

}
